<app-modal-form #modal [modalConfig]="modalConfig" [modalOptions]="modalOptions">
  <app-section-loader *ngIf="isFirstLoad" class="modal-potential-po__loader" />

  <app-card-empty
    *ngIf="hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_TROLLEY"
    text="Data PO tidak dapat dimuat."
  />

  <app-card-empty
    *ngIf="isEmpty && !hasError"
    [icon]="STRING_CONSTANTS.ICON.IC_TROLLEY"
    text="Belum terdapat PO."
  />

  <!--
    Tabel hanya disembunyikan, bukan dilepas dari DOM. `BaseDatasource.disconnect()` memanggil
    `tableSubject.complete()`, jadi begitu MatTable dilepas oleh `*ngIf` subject-nya mati dan
    baris tidak pernah muncul lagi.
  -->
  <div [class.d-none]="isFirstLoad || hasError || isEmpty">
    <div class="table-responsive">
      <table
        [dataSource]="dataSource"
        class="table w-100 table-row-bordered align-middle potential-po-table"
        mat-table
      >
        <ng-container *ngFor="let tableColumn of tableColumns" [matColumnDef]="tableColumn.key">
          <!-- [MAI-2608] Tidak ada kolom sortable: header polos untuk semua kolom. -->
          <th
            *matHeaderCellDef
            [ngClass]="{ 'w-80px text-center': tableColumn.key === 'actions' }"
            mat-header-cell
          >
            <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
              {{ tableColumn.title }}
            </app-table-content>
          </th>

          <td
            *matCellDef="let element"
            [ngClass]="{ 'w-80px text-center': tableColumn.key === 'actions' }"
            mat-cell
          >
            <ng-container [ngSwitch]="tableColumn.key">
              <!-- Total QTY: kuantitas di baris pertama, berat/satuan jual di baris kedua. -->
              <div *ngSwitchCase="'total_qty'">
                <app-table-content
                  [count]="2"
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'text'"
                >
                  <div>{{ element['total_qty'] }}</div>
                  <div class="modal-potential-po__weight">{{ element['weight'] }}</div>
                </app-table-content>
              </div>

              <!-- Status: label berwarna, memakai kelas badge global berdasarkan `status_enum`. -->
              <div *ngSwitchCase="'status_string'">
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <span
                    class="badge badge__status {{ 'badge__status--' + element['status_enum'] }}"
                  >
                    {{ element['status_string'] }}
                  </span>
                </app-table-content>
              </div>

              <!-- Tanggal Expired: tanggal di baris pertama, jam di baris kedua (pola tabel PO). -->
              <div *ngSwitchCase="'expired_date'">
                <app-table-content
                  [count]="2"
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'text'"
                >
                  <ng-container *ngIf="element['expired_date']; else noExpiredTpl">
                    <div>
                      {{ utilities.timeStampToDate(element['expired_date'], 'dd-MM-yyyy') }}
                    </div>
                    <div class="modal-potential-po__weight">
                      {{ utilities.timeStampToDate(element['expired_date'], 'HH:mm:ss') }}
                    </div>
                  </ng-container>
                  <ng-template #noExpiredTpl>
                    <div>-</div>
                  </ng-template>
                </app-table-content>
              </div>

              <!-- [AC-03] Ikon detail: membuka halaman Detail PO. -->
              <div
                *ngSwitchCase="'actions'"
                class="d-flex align-items-center justify-content-center"
              >
                <app-table-content
                  [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
                  [type]="'icon'"
                >
                  <span
                    (click)="onDetailPo(element)"
                    [inlineSVG]="STRING_CONSTANTS.ICON.IC_ACTIONS_TABLE"
                    class="svg-icon svg-icon-2 cursor-pointer"
                  ></span>
                </app-table-content>
              </div>

              <div *ngSwitchDefault>
                <app-table-content [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject">
                  <span>{{ element[tableColumn.key] }}</span>
                </app-table-content>
              </div>
            </ng-container>
          </td>
        </ng-container>

        <tr
          *matHeaderRowDef="displayedColumns"
          class="fw-bold text-start text-uppercase"
          mat-header-row
        ></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
    </div>

    <div class="d-flex justify-content-between pt-4">
      <app-mai-material-bottom-table
        (changePage)="onPageChange($event)"
        [baseDataTableComponent]="dataSource"
        [isFinishLoadingSubject]="dataSource.isFinishLoadingSubject"
        class="w-100"
      ></app-mai-material-bottom-table>
    </div>
  </div>
</app-modal-form>
